/* eslint-disable */

import Pivot from "./Pivot";

export default {
  name: "patientreport",
  components: {
    Pivot,
  },
    methods:{
      onclosed() {
        this.$router.push("./reportdashboard")
      }
    }
};